export default __webpack_public_path__ + "static/media/availableOnOculus.941fa73f.png";